import ConfirmModal from 'components/Modal/ConfirmModal'
import FormModal from 'components/Modal/FormModal'
import React, { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { IS_OPEN_MODAL } from 'core/store/global'
import KBPayLiveCancelModal from 'components/Modal/KBPayLiveCancelModal'

interface SectionModalProps {}

const SectionModal: React.FC<SectionModalProps> = (props) => {
  const [isOpenModalData, setIsOpenModalData] = useRecoilState(IS_OPEN_MODAL)
  const ModalEl = isOpenModalData?.type === 'form' ? FormModal : ConfirmModal

  useEffect(() => {
    if (isOpenModalData) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpenModalData])

  if (!isOpenModalData) return null

  const { title, message, termsUrl, confirmText, onConfirm, onSubmit } = isOpenModalData
  const handleClose = () => {
    setIsOpenModalData(null)
  }
  if (isOpenModalData?.type === 'kbpay-cancel') return <KBPayLiveCancelModal />
  return (
    <ModalEl
      title={title}
      message={message}
      confirmText={confirmText}
      termsUrl={termsUrl}
      onClose={handleClose}
      onConfirm={onConfirm}
      onSubmit={onSubmit}
    />
  )
}

export default SectionModal
